module.exports = __webpack_public_path__ + "static/4-ad45e85811ccd0f2fe32b751c4377f9c.png";